import { css } from '@styled-system/css';
import { Input } from 'antd';
import type { FC } from 'react';

export interface SearchBarNewProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export const SearchBarNew: FC<SearchBarNewProps> = ({ placeholder = 'Search', value, onChange, className }) => {
  return (
    <div className={`${css({ w: '245px' })} ${className || ''}`}>
      <Input.Search
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={css({
          width: '100%',
          '& .ant-input-search-button': {
            cursor: 'initial !important',
            backgroundColor: '#16171b !important',
            _hover: {
              outline: 'none !important',
              borderColor: '#1e1f24 !important',
              color: '#7b7b7d !important',
            },
          },
        })}
      />
    </div>
  );
};
